import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LockIcon(props: IconProps) {
    return <Icon {...props} iconKey={"lock"}/>
}
